module.exports = [
  {
    label: 'Mittagstisch anbieten',
    href: '/lunch',
  },
  {
    label: 'Abendessen anbieten',
    href: '/dinner',
  },
  {
    label: 'Wanderung anbieten',
    href: '/hiking',
  },
  {
    label: 'Malkurs anbieten',
    href: '/drawing',
  },
  {
    label: 'Yogakurs anbieten',
    href: '/yoga',
  },
  {
    label: 'Pilates anbieten',
    href: '/pilates',
  },
  {
    label: 'Fitness anbieten',
    href: '/fitness',
  },
  {
    label: 'Walking anbieten',
    href: '/walking',
  },
  {
    label: 'Ski-Tour anbieten',
    href: '/skiing',
  },
  {
    label: 'Jassrunde anbieten',
    href: '/jass',
  },
  // {
  //   label: 'Familienfest organisieren',
  //   href: '/family',
  // },
];
